import '../../../../base/common/strings.js';
import '../../../../base/common/network.js';
const TimelinePaneId = 'timeline';
const TIMELINE_SERVICE_ID = 'timeline';
export { TIMELINE_SERVICE_ID, TimelinePaneId };
